<template>
  <div id="container">
    <div class="item-box-content box-content-title">
      <div class="title-font-style">
        <span>采购询价报表</span>
      </div>
    </div>
    <div>
      <el-form class="search-style" :model="queryParams" label-position="left">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="日期：" label-width="45px">
              <el-date-picker
                v-model="time"
                style="width:100%;"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :default-time="['00:00:00','23:59:59']"
                 :clearable='false'
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="部门：" label-width="45px">
              <el-select v-model="org" @change='changeOrg' multiple placeholder="请选择">
                <el-option
                  v-for="(item,index) in department"
                  :key="index"
                  :label="item.orgName"
                  :value="item.orgId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="负责人：" label-width="60px">
              <el-select v-model="group" multiple>
                <el-option v-for="v in staffList" :key="v.id" :label="v.staffCnName" :value="v.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-col :span='12'>
              <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button @click="onReset">重置</el-button>
            </el-col>
            <el-col :span='12' style='text-align:right'>
               <el-button @click="exportOut">导出</el-button>
               </el-col>
          </el-col>
        </el-row>
      </el-form>
      <div class="box-table" :style="{height:tableHeight+'px'}">
        <el-table
          :summary-method="getSummaries"
          show-summary
          :max-height="tableHeight"
          border
          ref="tableRef"
          tooltip-effect="dark"
          :data="list"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column label="日期" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{ scope.row.date | dateFilterD}}</div>
            </template>
          </el-table-column>
          <el-table-column label="品牌" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{ scope.row.brandName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="系列" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.seriesName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="型号" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.proType || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="订货号" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.orderNumber || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">
              <div
                :class="scope.row.pccCount < 0 ? 'el-form-item__error' :''"
              >{{String(scope.row.ocNeedNumber) || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="货期">
            <template slot-scope="scope">
              <div>{{scope.row.ocExtime || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="反馈结果" width="120">
            <template slot-scope="scope">
              <div>{{scope.row.miStateName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="负责人">
            <template slot-scope="scope">
              <div>{{scope.row.userName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="所属部门">
            <template slot-scope="scope">
              <div>{{scope.row.orgName || '--'}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination" style="padding-bottom:0px">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import { isSuccess, downLoadFileBlob } from '@/util/tool'
import { queryInquiryReportOrgIds, queryInquiryReportUser, queryInquiryReport, exportInquiryReport } from '@/api/data/data'

export default {
  components: {
    pagination
  },
  mounted() {
    queryInquiryReportOrgIds().then(res => {
      // 部门
      if (isSuccess(res)) {
        this.department =
          res.data.obj
      }
    })
    this.addDate()
  },
  data() {
    return {
      showAll: false, // 是否展开全部
      time: [],
      group: [], // 负责人
      org: [], // 部门
      staffList: [],
      department: [],
      queryParams: {},
      tableHeight: window.innerHeight - 385,
      searchList: [],
      list: [],
      loadingTable: false, // 列表loading
      pageSize: 30, //
      currentPage: 1, // 页码
      total: 0, // 列表总数
      valList: [
        { value: '', column: 'orgIds' },
        { value: '', column: 'ownIds' }
      ],
      updateTime: ''

    }
  },

  methods: {
    // 默认展示当日所有采购所有的询价信息；
    addDate() {
      const nowDate = new Date()
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      }
      const newmonth = date.month < 10 ? '0' + date.month : date.month
      const newdate = date.date < 10 ? '0' + date.date : date.date
      this.updateTime = date.year + '-' + newmonth + '-' + newdate // 当前年月
      this.time = [this.updateTime, this.updateTime]
      this.onSearch()
    },
    getSummaries(param) {
      // 合计
      const sums = []
      param.columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
        } else if (index === 5) {
          sums[index] = param.data.reduce((tot, prov) => {
            return tot + +prov.ocNeedNumber
          }, 0)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    // 获取负责人
    changeOrg(val) {
      const str = val.join(',')
      if (val) {
        queryInquiryReportUser(str).then(res => {
          if (isSuccess(res)) {
            this.staffList = res.data.obj
          }
        })
      }
    },
    getList() {
      this.loadingTable = true
      const params = {
        criteriaVoList: this.searchList ? this.searchList : [],
        queryPageName: ''
      }
      queryInquiryReport(this.currentPage, this.pageSize, params).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.obj.records
          this.total = res.data.obj.total
          this.loadingTable = false
        }
      })
    },
    // 查询
    onSearch() {
      this.searchList = []
      if (this.time.length === 2) {
        this.searchList.push({
          value: this.time[0],
          endValue: this.time[1],
          column: 'date'
        })
      }
      this.valList[1].value = this.group.join(',')
      this.valList[0].value = this.org.join(',')
      if (this.valList.some(ele => ele.value) || this.time.length === 2) {
        this.pageSize = 30
        this.currentPage = 1
        this.valList.forEach(ele => {
          if (ele.value) {
            ele.collection = true
            this.searchList.push(ele)
          }
        })
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    // 重置
    onReset() {
      this.pageSize = 30
      this.currentPage = 1
      this.valList.forEach(ele => {
        delete ele.value
      })
      this.time = []
      this.group = []
      this.org = []
      this.searchList = []
      this.staffList = []
      this.getList()
    },
    // 导出
    exportOut() {
      const params = {
        criteriaVoList: this.searchList,
        queryPageName: ''
      }

      exportInquiryReport(params)
        .then(res => {
          downLoadFileBlob(this, res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-table th > .cell {
  font-weight: 500;
  color: #4e555b;
}
/deep/ .lpagination {
  padding-bottom: 20px;
}
</style>
